/* This file was automatically generated by CoralTypescriptTypesBuildLogic -- do not modify. */
/**
 * This represents the different types of permission that can be assigned to Actors.
 *
 * TODO: We are currently using Operation for this, but it is modeled as a String. Creating this enum with an
 * action item to replace all current occurrences of Operation with Permission
 * https:\/\/issues.amazon.com\/issues\/PECS-891
 **/
export var Permission;
(function (Permission) {
    Permission["ACCESS"] = "ACCESS";
    Permission["VIEW"] = "VIEW";
    Permission["EDIT"] = "EDIT";
    Permission["REVIEW"] = "REVIEW";
    Permission["ADMIN"] = "ADMIN";
})(Permission || (Permission = {}));
